import React, { useCallback, useState } from 'react';
import useIngredientTypeList from './hooks/useIngredientTypeList';
import IngredientsModal from './IngredientsModal';
import { showAlertSnackBar } from 'utils/Global';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { IngredientTypeModalDTO, ResponseType } from 'business/models/Models';
import { saveIngredientTypeModal } from 'business/services/IngredientService';
import { IngredientsModalType } from './IngredientEnums';

const TYPES_COLUMNS = [
  {
    accessor: 'name',
    Header: 'Ingredient Type',
    editOptions: { inputType: 'text' },
  },
];

const AddIngredientType = (props) => {
  const { showIngredientTypeModal, setShowIngredientTypeModal } = props;
  const [refetchCounter, setRefetchCounter] = useState(0);
  const ingredientTypeList = useIngredientTypeList(
    showIngredientTypeModal,
    refetchCounter,
  );

  const saveIngredientTypes = useCallback(async (allRows) => {
    const ingredientTypeData: IngredientTypeModalDTO = {} as IngredientTypeModalDTO;
    ingredientTypeData.ingredientTypes = [];
    ingredientTypeData.ingredientTypes = allRows;
    const result = await saveIngredientTypeModal(ingredientTypeData);
    if (result.responseType == ResponseType.Success) {
      showAlertSnackBar(
        EAlertType.SUCCESS,
        ESnackBarPosition.TOP,
        'Ingredient Type has been updated successfully!',
      );
      return true;
    } else if (result.responseType == ResponseType.Warning) {
      showAlertSnackBar(EAlertType.WARNING, ESnackBarPosition.TOP, result.message);
      setRefetchCounter(refetchCounter + 1);
      return false;
    }
  }, []);

  return (
    <IngredientsModal
      id='addingredienttype-wrapper'
      columns={TYPES_COLUMNS}
      saveModal={saveIngredientTypes}
      rowsData={ingredientTypeList}
      showModal={showIngredientTypeModal}
      setShowModal={setShowIngredientTypeModal}
      dialogClassName={'w-96'}
      heading="Ingredient Type"
      ingredientsModalType={IngredientsModalType.IngredientType}
    />
  );
};

export default AddIngredientType;
